<ul [class]="menuCSSClasses">
  <div class="vertical-menu">
    <li>
      @for (item of menuItems.sort(getMenuComparator); track item) {
        <span>
          @if (item.isInternalLink) {
            <a
              [ngClass]="item?.cssClasses"
              [queryParams]="getQueryParams(item)"
              [routerLink]="[item.link]"
              [routerLinkActiveOptions]="{ exact: false }"
              class="vertical-menu-item"
              routerLinkActive="selected">
              {{ item.translateKey | translate }}
            </a>
          }
          @if (item.isExternalLink) {
            <a [href]="item.link" [ngClass]="item?.cssClasses" class="vertical-menu-item" target="_blank">
              {{ item.translateKey | translate }}
            </a>
          }
          @if (item.deactivatedLink) {
            <a [class.selected]="item.isSelected" [ngClass]="item?.cssClasses" class="vertical-menu-item">
              {{ item.translateKey | translate }}
            </a>
          }
        </span>
      }
    </li>
  </div>
</ul>
